import { render } from "./Navbar.vue?vue&type=template&id=95e9d426&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=95e9d426&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Hardcore\\Documents\\LEARNING\\VUE PROJECT\\movie-review\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e9d426"]])

export default __exports__